import { Button } from "@/components/ui/button";
export default function ReadyToAutomate() {
  return <section data-section-id="230167" id="ready-to-automate" className="relative w-full bg-background bg-gradient-to-b from-background to-black py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center opacity-10 pointer-events-none select-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688847/img/datazen_network_nodes.png" alt="" className="w-full max-w-[1200px] object-contain animate-pulse" aria-hidden="true" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center justify-center gap-10">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground text-center max-w-3xl leading-tight tracking-tighter">
          Ready to Automate?
        </h2>

        <Button size="lg" className="h-16 px-12 text-lg md:text-xl font-default font-bold tracking-wider uppercase transition-all duration-300 bg-gradient-to-r from-primary to-chart-2 text-primary-foreground shadow-lg shadow-primary/30 hover:shadow-2xl hover:shadow-primary/50 hover:-translate-y-1 animate-pulse" onClick={() => document.getElementById('contactgetintouch')?.scrollIntoView({
        behavior: 'smooth'
      })}>
          Book Free Consultation
        </Button>
      </div>
    </section>;
}